import {CSSObjectWithLabel} from 'react-select';
export const TAG_SELECT_STYLE_OVERRIDES = {
  container: (provided: CSSObjectWithLabel, {hasValue, isFocused}: any) => ({
    ...provided,
    display: 'inline-block',
    flex: hasValue ? '1' : undefined,
    width: isFocused ? '100%' : 'auto',
  }),
  control: (provided: CSSObjectWithLabel) => ({
    ...provided,
    border: 'none',
  }),
  placeholder: (provided: CSSObjectWithLabel, {isFocused}: {isFocused: boolean}) => ({
    ...provided,
    color: 'var(--color-secondary-blue)',
  }),
  valueContainer: (provided: CSSObjectWithLabel) => ({
    ...provided,
  }),
  input: (provided: CSSObjectWithLabel) => ({
    ...provided,
    width: 'auto',
    minWidth: '3.5em',
  }),
  indicatorsContainer: (provided: CSSObjectWithLabel) => ({
    ...provided,
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  clearIndicator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (provided: CSSObjectWithLabel) => ({
    color: 'var(--color-secondary-blue)',
  }),
  menu: (provided: CSSObjectWithLabel) => ({
    ...provided,
    minWidth: '100%',
    width: 'auto',
  }),
} as const;
